import Vue from 'vue';
import VueI18n from 'vue-i18n';
import _ from 'lodash';
import {
    currentLang
} from '../../config.js';
import {getMessages} from './messagesProvider.js'

const messages = _.merge(getMessages.fromCore(), getMessages.fromAdaptation());

Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: currentLang,
    messages: messages
});

export default i18n;


// WEBPACK FOOTER //
// ./src/components/i18n/index.js